import * as React from 'react';
export const ReadyIllustration = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="ready-illustration"
    viewBox="0 0 256 192"
  >
    <defs>
      <clipPath id="clippath">
        <path d="M-478.51-5092.6h163.02v163.02h-163.02z" className="cls-1" />
      </clipPath>
      <clipPath id="clippath-1">
        <path d="M-478.11-5092.07h163.02v163.02h-163.02z" className="cls-1" />
      </clipPath>
      <style>
        {
          '.cls-1,.cls-3{fill:none}.cls-5{fill:#f470bd}.cls-7{fill:#fff}.cls-8{fill:#fdc221}.cls-10{fill:#6e56e6}.cls-11{fill:#56d3df}.cls-3{stroke-linecap:round;stroke:#fff;stroke-miterlimit:10;stroke-width:3.42px}'
        }
      </style>
    </defs>
    <g
      style={{
        clipPath: 'url(#clippath)',
      }}
    >
      <path
        d="M3689.26-6300.33h-15361.67v8770.71H3689.26v-8770.71Z"
        className="cls-7"
        style={{
          clipPath: 'url(#clippath-1)',
        }}
      />
    </g>
    <path
      d="M133.66 51.61c0 3.6-2.92 6.51-6.51 6.51s-6.51-2.92-6.51-6.51 2.92-6.51 6.51-6.51 6.51 2.92 6.51 6.51Zm-6.51-2.2c-1.21 0-2.2.98-2.2 2.2s.98 2.2 2.2 2.2 2.2-.98 2.2-2.2-.98-2.2-2.2-2.2Z"
      className="cls-8"
    />
    <path
      d="M102.89 41.8c0 3.62-2.93 6.55-6.55 6.55s-6.55-2.93-6.55-6.55 2.93-6.55 6.55-6.55 6.55 2.93 6.55 6.55Zm-6.55-2.21a2.21 2.21 0 1 0 .001 4.421 2.21 2.21 0 0 0-.001-4.421Z"
      className="cls-10"
    />
    <path
      d="M114.13 54.86c-5.39 0-9.77 4.37-9.77 9.77h9.77v-9.77Z"
      className="cls-11"
    />
    <path
      d="M156.45 32.07c5.39 0 9.77 4.37 9.77 9.77h-9.77v-9.77Z"
      className="cls-8"
    />
    <path
      d="m137.48 38.979 6.908-6.908 2.305 2.305-6.909 6.908z"
      className="cls-10"
    />
    <path
      d="M158.08 48.39h-3.26a4.87 4.87 0 0 1-3.27 4.59v-1.34c0-2.69-2.19-4.88-4.88-4.88s-4.88 2.19-4.88 4.88 2.19 4.88 4.88 4.88H148a4.868 4.868 0 0 1-4.58 3.23v3.26c3.97 0 7.27-2.86 7.98-6.63 3.79-.69 6.67-4 6.67-7.99Zm-13.02 3.25c0-.89.73-1.62 1.62-1.62s1.62.73 1.62 1.62v1.62h-1.62c-.89 0-1.62-.73-1.62-1.62Z"
      className="cls-11"
    />
    <path
      d="M119.01 28.81c0-2.69-2.19-4.88-4.88-4.88s-4.88 2.19-4.88 4.88v1.33a4.868 4.868 0 0 1-3.23-4.58h-3.26c0 3.97 2.86 7.27 6.63 7.98.69 3.79 4 6.67 7.99 6.67v-3.26a4.87 4.87 0 0 1-4.59-3.27h1.35c2.69 0 4.88-2.19 4.88-4.88Zm-6.5 0c0-.89.73-1.62 1.62-1.62s1.62.73 1.62 1.62-.73 1.62-1.62 1.62h-1.62v-1.62Z"
      style={{
        fill: '#ee399e',
      }}
    />
    <circle cx={133.66} cy={67.88} r={3.26} className="cls-5" />
    <circle cx={133.66} cy={25.56} r={3.26} className="cls-8" />
    <path
      d="m120.644 73.999 2.305-2.305 6.909 6.908-2.305 2.305z"
      className="cls-10"
    />
    <rect
      width={64.81}
      height={75.89}
      x={95.59}
      y={89.01}
      className="cls-5"
      rx={9.9}
      ry={9.9}
    />
    <path d="M133.26 115.1h16.36M133.26 105.21h16.36" className="cls-3" />
    <rect
      width={21.87}
      height={21.87}
      x={104.8}
      y={99.22}
      rx={6.48}
      ry={6.48}
      style={{
        fill: '#072462',
      }}
    />
    <path
      d="M109.44 117.72c0-3.48 2.82-6.29 6.29-6.29s6.29 2.82 6.29 6.29"
      className="cls-7"
    />
    <circle cx={115.73} cy={106.7} r={3.15} className="cls-7" />
    <path
      d="m116.31 139.45 7.97 7.97 15.41-15.41"
      style={{
        strokeLinecap: 'round',
        stroke: '#503dc9',
        strokeLinejoin: 'round',
        strokeWidth: '9.9px',
        fill: 'none',
      }}
    />
  </svg>
);
